/**
 * thx-pixel-emq.js
 * Meta Pixel Event Match Quality Booster
 * The Home Xperts — Pixel ID: 689027802406683
 * Ported to Ella (THX - New Theme - OS 3.0) on 2026-07-20
 *
 * Requires the companion inline blocks in layout/theme.liquid:
 *   1. Early fbc/fbp capture script (in <head>, before content_for_header)
 *   2. window.__thxCustomer block (end of <head>, logged-in customers only)
 */
(function () {
  'use strict';

  function getCookie(name) {
    var rx = new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()[\]\\^\/+])/g, '\\$1') + '=([^;]*)');
    var m = document.cookie.match(rx);
    return m ? decodeURIComponent(m[1]) : null;
  }

  (function pushCustomerData() {
    try {
      var customer = window.__thxCustomer;
      if (!customer) return;

      window.dataLayer = window.dataLayer || [];

      function sha256(str) {
        if (!str || !crypto || !crypto.subtle) return Promise.resolve(null);
        var normalized = String(str).trim().toLowerCase();
        var encoded = new TextEncoder().encode(normalized);
        return crypto.subtle.digest('SHA-256', encoded).then(function (buf) {
          return Array.from(new Uint8Array(buf))
            .map(function (b) { return b.toString(16).padStart(2, '0'); })
            .join('');
        });
      }

      Promise.all([
        sha256(customer.email),
        sha256(customer.phone)
      ]).then(function (hashes) {
        var emHash = hashes[0] || null;
        var phHash = hashes[1] || null;
        var fbc = getCookie('_fbc') || getCookie('thx_fbc') || null;
        var fbp = getCookie('_fbp') || getCookie('thx_fbp') || null;

        window.dataLayer.push({
          event: 'thx_customer_data',
          thx_em: emHash,
          thx_ph: phHash,
          thx_external_id: customer.id || null,
          thx_fbc: fbc,
          thx_fbp: fbp
        });

        if (typeof window.fbq === 'function' && emHash) {
          var advancedMatching = { em: emHash };
          if (phHash) advancedMatching.ph = phHash;
          if (customer.id) advancedMatching.external_id = String(customer.id);
          if (fbc) advancedMatching.fbc = fbc;
          if (fbp) advancedMatching.fbp = fbp;
          window.fbq('init', '689027802406683', advancedMatching);
        }
      }).catch(function () {});
    } catch (e) {}
  })();

})();

/* ===== THX Fast ATC — instant feedback on Add To Cart (v7) ===== */
(function () {
  'use strict';
  if (window.__thxFastAtc) return;
  window.__thxFastAtc = 1;

  try {
    var css = '' +
      '.thx-fa{position:fixed;left:12px;right:12px;bottom:calc(14px + env(safe-area-inset-bottom));z-index:2147483000;background:#1f1f1f;color:#fff;border-radius:12px;padding:11px 12px 11px 14px;display:flex;align-items:center;gap:10px;font-family:inherit;font-size:14px;font-weight:700;line-height:1.3;box-shadow:0 8px 24px rgba(0,0,0,.25);transform:translateY(160%);opacity:0;transition:transform .22s ease,opacity .22s ease;pointer-events:none}' +
      '.thx-fa.show{transform:none;opacity:1;pointer-events:auto}' +
      '.thx-fa.err{background:#b3261e}' +
      '.thx-fa__t{flex:1;min-width:0}' +
      '.thx-fa__ok{display:inline-flex;align-items:center;justify-content:center;width:22px;height:22px;border-radius:50%;background:#4eae38;color:#fff;font-size:13px;flex:0 0 22px}' +
      '.thx-fa a{color:#fff;background:#4eae38;padding:9px 12px;border-radius:8px;text-decoration:none;font-weight:800;font-size:12.5px;letter-spacing:.04em;white-space:nowrap}' +
      '.thx-fa.err a{display:none}' +
      '.thx-atc-busy{position:relative!important;pointer-events:none!important;opacity:.85}' +
      '.thx-atc-busy::after{content:"";position:absolute;right:14px;top:50%;width:16px;height:16px;margin-top:-8px;border:2px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:thxFaSpin .6s linear infinite}' +
      '@keyframes thxFaSpin{to{transform:rotate(360deg)}}' +
      '@media (min-width:768px){.thx-fa{left:auto;right:20px;width:380px}}' +
      /* toast on top for mobile so it never covers the sticky ATC */
      '@media (max-width:767px){.thx-fa{top:calc(10px + env(safe-area-inset-top));bottom:auto;transform:translateY(-160%);font-size:13px;padding:9px 10px 9px 12px}.thx-fa a{padding:7px 10px;font-size:11.5px}}' +
      /* ---- compact, professional mobile Add To Cart ---- */
      '@media (max-width:767px){' +
        '.thx-sb .thx-sb__bar{padding:8px 10px calc(8px + env(safe-area-inset-bottom))!important;border-radius:14px 14px 0 0!important}' +
        '.thx-sb .thx-sb__top{gap:8px!important}' +
        '.thx-sb .thx-sb__img{flex:0 0 36px!important;width:36px!important;height:36px!important;border-radius:6px!important}' +
        '.thx-sb .thx-sb__ttl{font-size:12px!important;font-weight:700!important}' +
        '.thx-sb .thx-sb__sel{font-size:10.5px!important}' +
        '.thx-sb .thx-sb__sg{height:24px!important;padding:0 8px!important;font-size:9.5px!important}' +
        '.thx-sb .thx-sb__bot{gap:8px!important;margin-top:7px!important}' +
        '.thx-sb .thx-sb__sum{min-width:72px!important}' +
        '.thx-sb .thx-sb__price{font-size:14px!important}' +
        '.thx-sb .thx-sb__chg{font-size:10px!important}' +
        '.thx-sb .thx-sb__atc{height:40px!important;min-width:0!important;padding:0 10px!important;border-radius:8px!important;font-size:12.5px!important;letter-spacing:.04em!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}' +
        '.thx-sb.open .thx-sb__panel{max-height:55vh!important;padding:12px 10px 4px!important}' +
        '.thx-atc-row{gap:6px!important}' +
        '.thx-atc-row .quantity__container{height:42px!important;border-radius:8px!important}' +
        '.thx-atc-row .quantity__container .btn-quantity{width:32px!important;height:40px!important}' +
        '.thx-atc-row .quantity__input{width:26px!important;height:40px!important;font-size:14px!important}' +
        '.thx-atc-row [type="submit"]{height:42px!important;min-height:42px!important;font-size:13px!important;letter-spacing:.04em!important;padding:0 10px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}' +
        '.thx-x__buy{height:42px!important;font-size:13px!important;letter-spacing:.04em!important;border-radius:8px!important;padding:0 10px!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important}' +
        '.thx-atc-busy::after{right:10px;width:14px;height:14px;margin-top:-7px}' +
      '}' +
      '@media (max-width:360px){' +
        '.thx-sb .thx-sb__img{display:none!important}' +
        '.thx-sb .thx-sb__price{font-size:13px!important}' +
        '.thx-sb .thx-sb__atc,.thx-atc-row [type="submit"],.thx-x__buy{font-size:12px!important;letter-spacing:.02em!important}' +
        '.thx-atc-row .quantity__container .btn-quantity{width:28px!important}' +
      '}';
    var st = document.createElement('style');
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);

    var toast, hideT, busyT;

    function getToast() {
      if (toast) return toast;
      toast = document.createElement('div');
      toast.className = 'thx-fa';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.innerHTML = '<span class="thx-fa__ok">✓</span><span class="thx-fa__t"></span><a href="/checkout">CHECKOUT →</a>';
      document.body.appendChild(toast);
      return toast;
    }

    function show(msg, isErr) {
      var t = getToast();
      t.querySelector('.thx-fa__t').textContent = msg;
      t.querySelector('.thx-fa__ok').textContent = isErr ? '!' : '✓';
      t.classList.toggle('err', !!isErr);
      t.classList.add('show');
      clearTimeout(hideT);
      hideT = setTimeout(function () { t.classList.remove('show'); }, isErr ? 3500 : 4500);
    }

    function setBusy(on) {
      var btns = document.querySelectorAll('form[action*="/cart/add"] [type="submit"][name="add"], #thx-sb-atc');
      for (var i = 0; i < btns.length; i++) btns[i].classList.toggle('thx-atc-busy', on);
      clearTimeout(busyT);
      if (on) busyT = setTimeout(function () { setBusy(false); }, 5000);
    }

    function isAdd(url) {
      try { return /\/cart\/add(\.js)?(\?|$)/.test(String(url && url.url ? url.url : url)); } catch (e) { return false; }
    }

    function done(ok, body) {
      setBusy(false);
      if (ok) {
        show('Cart mein add ho gaya!');
      } else {
        var m = '';
        try { var j = JSON.parse(body || '{}'); m = j.description || j.message || ''; } catch (e) {}
        show(m || 'Ye size abhi available nahi — doosra size select karein', true);
      }
    }

    /* Instant busy state the moment ATC is tapped */
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"][name="add"], #thx-sb-atc');
      if (!b || b.disabled) return;
      setBusy(true);
    }, true);

    /* Hook fetch */
    if (window.fetch) {
      var of = window.fetch;
      window.fetch = function (input) {
        var p = of.apply(this, arguments);
        if (isAdd(input)) {
          p.then(function (r) {
            if (r.ok) done(true);
            else r.clone().text().then(function (t) { done(false, t); }, function () { done(false); });
          }, function () { setBusy(false); });
        }
        return p;
      };
    }

    /* Hook XHR (jQuery ajax) */
    var XO = XMLHttpRequest.prototype.open, XS = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__thxAdd = isAdd(u); return XO.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      if (this.__thxAdd) {
        var x = this;
        x.addEventListener('loadend', function () {
          if (x.status >= 200 && x.status < 300) done(true);
          else if (x.status) done(false, x.responseText);
          else setBusy(false);
        });
      }
      return XS.apply(this, arguments);
    };
  } catch (e) {}
})();
